import { Autocomplete, TextField } from '@mui/material';
import React from 'react'

export default function BookingClassInput({value,setValue,label}) {
  return (
    <div>
        <Autocomplete size="small" options={[...Array(26)].map((_, i) => String.fromCharCode(65 + i))}
            value={value} selectOnFocus 
            onChange={(ev,val) => {
                setValue && setValue(val)
            }}
            // filterOptions={(options, params) => {
            //     const filtered = [...options]

            //     const { inputValue } = params;
            //     // Suggest the creation of a new value
            //     const isExisting = options.some((option) => inputValue === option.title);
            //     if (inputValue !== '' && !isExisting) {
            //     filtered.push({
            //         inputValue,
            //         title: `Add "${inputValue}"`,
            //     });
            //     }

            //     return filtered;
            // }}
            renderInput={(params) => (
                <TextField {...params} label={label || 'Booking Class'} />
            )}
            renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                    <li key={key} {...optionProps}>
                        {option}
                    </li>
                );
            }}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                    return option.inputValue;
                }
                // Regular option
                return option.title;
            }}
            clearOnBlur
            blurOnSelect

        />      
    </div>
  )
}
